export default __webpack_public_path__ + "static/media/legend-DWF.cea0b58c.png";